import React, { useRef, useState } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Paper,
  Divider,
  Grid,
  Badge,
  IconButton,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  DialogContent,
  MenuItem,
  OutlinedInput,
  Chip,
  TextField,
  Stack,
  Container,
} from '@mui/material';
import capitalizeFirstLetter from 'utils/capitalizeFirstLetter';
import EditIcon from '@mui/icons-material/Edit';
import API from 'api/API';
import { useAuth } from 'providers/AuthContextProvider';
import { useNavigate } from 'react-router-dom';
import { isValidCurp } from 'utils/isValidCurp';
import CPGoogleGeocode from 'views/son/components/CPGoogleGeocode';
import EmergencyContactsField from 'views/son/components/EmergencyContactsField';
import CardexDialog from 'components/CardexDialog';
import UpdateCredentialsDialog from './components/UpdateCredentialsDialog';
import DeleteAccountForm from './components/DeleteAccountForm';

const Profile = () => {
    const navigate = useNavigate()
    const fileInputRef = useRef()
    const [loading, setLoading] = useState(false)
    const {user, setUser} = useAuth();
    const [snackbarState, setSnackbarState] = React.useState({open: false, message: "", status: "info"});
    const [avatarPreview, setAvatarPreview] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogPassword, setOpenDialogPassword] = useState(false);
    const [gender, setGender] = useState(null);
    const [secure, setSecure] = useState(null);
    const [civilState, setCivilState] = useState(null);
    const [address1, setAddress1] = useState(null)
    const [selectedStd, setSelectedStd] = React.useState([]);
    const [selectedCdd, setSelectedSdd] = React.useState([]);
    const [selectedSports, setSelectedSports] = React.useState([]);
    const [selectedDrugAllergies, setSelectedDrugAllergies] = React.useState([]);
    const [selectedAllergies, setSelectedAllergies] = React.useState([]);
    const [selectedDisabilities, setSelectedDisabilities] = React.useState([]);
    const [selectedBlood, setSelectedBlood] = React.useState(null);
    const [contacts, setContacts] = useState([ { name: "", relationship: "", phone: "" }]);
    const [columns,setColumns] = React.useState(
        [
            { 
                id: 'name', 
                label: 'Nombre', 
                defaultValue:  null,
                required: true,
                type:"text",
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:3,
                xl:4,
            },
            { 
                id: 'last_name', 
                label: 'Apellido paterno', 
                defaultValue: null,
                required: true,
                type:"text",
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'maternal_surname',
                label: 'Apellido materno',
                defaultValue: null,
                type:'text',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'birth_date',
                label: 'Fecha de nacimiento',
                defaultValue: null,
                required: true,
                type:'date',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'telephone',
                label: 'Telefono de contacto',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
            },
            {
                id: 'gender',
                label: 'Genero',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:3,
                xl:3,
                options:['Masculino', 'Femenino']
            },
            {
                id: 'secure',
                label: 'Seguro medico',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
                options:['IMSS', 'ISSTE', 'Privado', 'Ninguno']
            },
            {
                id: 'sexually_transmitted_disease',
                label: 'Enfermedades de transmicion sexual',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:7, 
                md:7,
                lg:7,
                xl:7,
                options: ['Ninguna', 'VIH/SIDA', 'Sífilis', 'Gonorrea', 'Clamidia', 'Herpes genital', 'Virus del Papiloma Humano (VPH)', 'Tricomoniasis', 'Hepatitis B', 'Hepatitis C', 'Linfogranuloma venéreo (LGV)', 'Chancro blando', 'Granuloma inguinal', 'Molusco contagioso', 'Uretritis no gonocócica', 'Vaginosis bacteriana', 'Otros']
            },
            {
                id: 'chronic_degenerative_diseases',
                label: 'Enfermedades generativas cronicas',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:7, 
                md:7,
                lg:7,
                xl:7,
                options:['Ninguna', 'Diabetes mellitus tipo 2', 'Hipertensión arterial', 'Enfermedad renal crónica', 'Enfermedades cardiovasculares', 'Cáncer (mama, próstata, cervicouterino, pulmón, colon)', 'Obesidad y sobrepeso', 'Enfermedad pulmonar obstructiva crónica (EPOC)', 'Artritis reumatoide', 'Osteoartritis', 'Asma crónica', 'Demencias (como Alzheimer)']
            },
            {
                id: 'sport',
                label: 'Pratica algun deporte',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
                options: ['Ninguno', 'Fútbol', 'Básquetbol', 'Béisbol', 'Boxeo', 'Lucha libre', 'Natación', 'Atletismo', 'Ciclismo', 'Voleibol', 'Tenis', 'Frontón', 'Taekwondo', 'Gimnasia', 'Karate', 'Skateboarding', 'Charrería', 'Artes marciales mixtas (MMA)', 'Senderismo', 'Escalada', 'Golf']
            },
            {
                id: 'age',
                label: 'Edad',
                defaultValue:  null,
                required: true,
                type:'number',
                disabled:false,
                xs:12, 
                sm:2, 
                md:2,
                lg:2,
                xl:2,
            },
            {
                id: 'weight',
                label: 'Peso en KG',
                defaultValue:  null,
                required: true,
                type:'number',
                disabled:false,
                xs:12, 
                sm:3, 
                md:3,
                lg:3,
                xl:3,
            },
            {
                id: 'height',
                label: 'Altura en CM',
                defaultValue:  null,
                required: true,
                type:'number',
                disabled:false,
                xs:12, 
                sm:3, 
                md:3,
                lg:3,
                xl:3,
            },
            {
                id: 'cellphone',
                label: 'Celular',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
            },
            {
                id: 'curp',
                label: 'CURP',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:6, 
                md:6,
                lg:6,
                xl:6,
            },
            {
                id: 'civil_state',
                label: 'Estado civil',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options:['Soltero/a', 'Casado/a', 'Unión libre', 'Divorciado/a', 'Viudo/a', 'Separado/a']
            },
            {
                id: 'drug_allergy',
                label: 'Alergia a farmacos',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options: ['Ninguna', 'Penicilina', 'Amoxicilina', 'Cefalosporinas', 'Sulfonamidas', 'Aspirina (ácido acetilsalicílico)', 'Ibuprofeno', 'Paracetamol', 'Antiinflamatorios no esteroides (AINEs)', 'Anestésicos locales (como lidocaína)', 'Anticonvulsivos (como fenitoína o carbamazepina)', 'Contrastes yodados', 'Vacunas', 'Otros']
            },
            {
                id: 'common_allergies',
                label: 'Alergias',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options: ['Ninguna', 'Polen', 'Ácaros del polvo', 'Polvo', 'Caspa de perro', 'Caspa de gato', 'Picadura de abeja', 'Lácteos', 'Gluten', 'Mariscos', 'Cacahuates', 'Nueces', 'Frutas (como plátano o fresa)', 'Moho', 'Medicamentos', 'Látex', 'Otros']
            },
            {
                id: 'disabilities',
                label: 'Discapacidades',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options:['Ninguna', 'Discapacidad visual', 'Discapacidad auditiva', 'Discapacidad motriz', 'Discapacidad intelectual', 'Discapacidad psicosocial (mental)', 'Discapacidad del habla o lenguaje', 'Discapacidad múltiple', 'Autismo o espectro autista', 'Síndrome de Down', 'Parálisis cerebral', 'Otros']
            },
            {
                id: 'blood_type',
                label: 'Tipo de sangre',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:3, 
                md:3,
                lg:3,
                xl:3,
                options:['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
            },
            {
                id: 'address_1',
                label: 'Direccion por codigo postal',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:8, 
                md:8,
                lg:8,
                xl:8,
            },
            {
                id: 'address_2',
                label: 'Calle y numero',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:8, 
                md:8,
                lg:8,
                xl:8,
            },
            {
                id: 'emergency_contacts',
                label: 'Contactos de emergencia',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:12,
                xl:12,
            },
        ]
    );

    if (!user) return <Typography>Cargando usuario...</Typography>

    const createdDate = new Date(user.date._seconds * 1000);

    
    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Mostrar preview
        const previewURL = URL.createObjectURL(file);
        setAvatarPreview(previewURL);

        // Subir imagen
        const response = await API.postMedia(file, { folder: "users", filename: user.id });

        if (response.status === 200) {
            console.log("✅ Imagen subida correctamente:", response.data);
            const url  = response.data.url
            const requestBody = user
            requestBody.image_url = url
            const responsePatchUser = await API.patchUser(requestBody)
            if (responsePatchUser.status === 200) {
                setUser(responsePatchUser.data)
                console.log("✅ Información actualizada correctamente:", responsePatchUser.data);
            } else {
                console.error("❌ Error al actualizar información:", responsePatchUser.message);
            }
        } else {
            console.error("❌ Error al subir imagen:", response.message);
        }
    };

    const onClickCardex = ()=>{
        getCardex()
    }
    const getCardex = async()=>{
        const userId = user.id
        const queryParams = {
            user_id: userId
        }
        const response = await API.getCardex(queryParams)
        
        if(response.status == 200){
            navigate("/cardex",{state:response.data[0]})
        }else{
            setOpenDialog(true)
            //setSnackbarState({open:true, message: "No se econtraron registros", status: "error"})
        }
    }
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const handleChangeStd= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedStd(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeCdd= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedSdd(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeSports= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedSports(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeDrugAllergies= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedDrugAllergies(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeAllergies = (event) => {
        const {
        target: { value },
        } = event;
        setSelectedAllergies(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeDisabilities = (event) => {
        const {
        target: { value },
        } = event;
        setSelectedDisabilities(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeSecure = (event)=>{
        setSecure(event.target.value)
    }
    const handleChangeGender = (event)=>{
        setGender(event.target.value)
    }
    const handleChangeBlood = (event)=>{
        setSelectedBlood(event.target.value)
    }
    const handleChangeCivilState = (event)=>{
        setCivilState(event.target.value)
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        // 1. Declarar variables del formulario
        const name = data.get('name');
        const lastName = data.get('last_name');
        const maternalSurname = data.get('maternal_surname');
        const birthDate = data.get('birth_date');
        const telephone = data.get('telephone');
        const cellphone = data.get('cellphone');

        const age = data.get('age');
        const weight = data.get('weight');
        const height = data.get('height');
        const curp = data.get('curp');
        const address2 = data.get('address_2');
        //const emergencyContacts = data.get('emergency_contacts');

        // 2. Validaciones básicas
        if (!isValidCurp(curp)) {
            setSnackbarState({
                open: true,
                message: "Proporciona un CURP válido",
                status: "warning",
            });
            return;
        }

        if (!name || !lastName || !birthDate) {
            setSnackbarState({
                open: true,
                message: "Nombre, apellido y fecha de nacimiento son obligatorios",
                status: "warning",
            });
            return;
        }

        // 3. Construir el requestBody
        const requestBody = {
            user_id: user.id,
            name: name,
            last_name: lastName,
            maternal_surname: maternalSurname,
            birth_date: birthDate,
            telephone: telephone,
            cellphone: cellphone,
            gender: gender,
            secure: secure,
            sexually_transmitted_disease: selectedStd,
            chronic_degenerative_diseases: selectedCdd,
            sport: selectedSports,
            age: Number(age),
            weight: Number(weight),
            height: parseFloat(height),
            curp: curp,
            civil_state: civilState,
            drug_allergy: selectedDrugAllergies,
            common_allergies: selectedAllergies,
            disabilities: selectedDisabilities,
            blood_type: selectedBlood,
            medical_history: null,
            address: address2+' '+address1,
            emergency_contacts: contacts,
        };

        // 4. Enviar petición
        setLoading(true)
        const response = await API.postCardex(requestBody);
        setLoading(false)

        if (response.status === 200) {
            setSnackbarState({
                open: true,
                message: response.message,
                status: "success",
            });
            handleCloseDialog(); 
        } else {
            setSnackbarState({
                open: true,
                message: response.message || "Error inesperado",
                status: "error",
            });
        }

    };

    return (
        <>
            <Paper elevation={false} sx={{ p: 3, mx: 'auto',my:2 }}>   
                <Box display="flex" flexDirection="column" alignItems="flex-start" mb={1} >
                    <Badge overlap="circular"  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                        <IconButton
                            size="small"
                            color="primary"
                            sx={{
                                bgcolor: 'background.paper',
                                boxShadow: 1,
                                '&:hover': { bgcolor: 'grey.200' },
                                width: 28,
                                height: 28,
                                p: 0,
                            }}
                            onClick={() => fileInputRef.current.click()}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                        }
                    >
                        <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                        <Avatar
                            alt={user.name}
                            src={avatarPreview || user.image_url}
                        
                            sx={{ cursor: "pointer", width: 100, height: 100}}
                        />
                    </Badge>

                    <Typography variant="h5" fontWeight="bold" gutterBottom sx={{mt:2}}>
                        {capitalizeFirstLetter(user?.name)} {capitalizeFirstLetter(user?.last_name)} {capitalizeFirstLetter(user?.maternal_surname)}
                    </Typography>
                </Box>
                <Divider sx={{ mb: 3 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            CURP
                        </Typography>
                        <Typography>{user.curp?.toUpperCase()}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Email
                        </Typography>
                        <Typography>{user.email}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Teléfono
                        </Typography>
                        <Typography>{user.telephone}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Fecha de registro
                        </Typography>
                        <Typography>{createdDate.toLocaleDateString()}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Estado de email
                        </Typography>
                        <Typography>{user.verifiedEmail ? "Verificado" : "No verificado"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Estado
                        </Typography>
                        <Typography>{user.status ? "Activo" : "Inactivo"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Membresía
                        </Typography>
                        <Typography>{user.membership || "-"}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Stack spacing={1} direction={'row'}>
                        <Button onClick={onClickCardex} variant='outlined'>ver cardex</Button>

                        <Button onClick={() => setOpenDialogPassword(true)} variant='outlined'>Actualizar contraseña</Button>
                        </Stack>
                    </Grid>
                </Grid>
            </Paper>
            {/* Modal para agregar cardex */}
            
            <Paper elevation={false} sx={{ p: 3, mx: 'auto',my:2 }}>
                <DeleteAccountForm setSnackbarState={setSnackbarState}></DeleteAccountForm>
            </Paper>

            <CardexDialog
                open={openDialog}
                onClose={handleCloseDialog}
                onSubmit={handleSubmit}
                loading={loading}
                title="Agregar Cardex"
                columns={columns}
                extraProps={{
                    gender: { value: gender, onChange: handleChangeGender },
                    secure: { value: secure, onChange: handleChangeSecure },
                    sexually_transmitted_disease: { value: selectedStd, onChange: handleChangeStd },
                    chronic_degenerative_diseases: { value: selectedCdd, onChange: handleChangeCdd },
                    sport: { value: selectedSports, onChange: handleChangeSports },
                    civil_state: { value: civilState, onChange: handleChangeCivilState },
                    drug_allergy: { value: selectedDrugAllergies, onChange: handleChangeDrugAllergies },
                    common_allergies: { value: selectedAllergies, onChange: handleChangeAllergies },
                    disabilities: { value: selectedDisabilities, onChange: handleChangeDisabilities },
                    blood_type: { value: selectedBlood, onChange: handleChangeBlood },
                    setAddress1,
                    contacts,
                    setContacts,
                }}
            />

            <UpdateCredentialsDialog
                open={openDialogPassword}
                onClose={() => setOpenDialogPassword(false)}
                onSubmit={(data) => console.log("Formulario enviado:", data)}
            />

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState.open} onClose={handleCloseSnackBar}>
                <Alert
                    onClose={handleCloseSnackBar}
                    severity={snackbarState.status}
                    variant="filled"
                >
                    {snackbarState.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default Profile;
